
import React, { Component } from 'react';
import { Modal, Form, Input, InputNumber, Select, DatePicker } from 'antd';

import http from '../../../axios/http';
import messager from '../../ui/messager';
import Image from '../../ui/Image';
import moment from 'moment';

const fields = [{
    "text": "专区类型",
    "field": "type",
    select: true,
    rules: [
        { required: true, message: '专区类型不能为空!' },
    ]
}, {
    "text": "专区名称",
    "field": "name",
    rules: [
        { required: true, message: '专区名称不能为空!' },
        { max: 32, message: '专区名称不能超过32个字符！' },
    ]
}, {
    "text": "显示顺序",
    "field": "sequence",
    "number": true,
    rules: [
        { required: true, message: '显示顺序不能为空!' },
    ]
}, {
    "text": "开始时间",
    "field": "startTime",
    "date": true,
    rules: [
        { required: true, message: '开始时间不能为空!' },
    ]
}, {
    "text": "结束时间",
    "field": "endTime",
    "date": true,
    rules: [
        { required: true, message: '结束时间不能为空!' },
    ]
}, {
    "text": "专区说明",
    "field": "content",
    textarea: true
}, {
    "text": "专区入口图片",
    "field": "enter",
    image: true
}, {
    "text": "专区展示页图片",
    "field": "display",
    image: true
}];


class CarouselEditForm extends Component {

    state = {
        enter: {
            imageUrl: null,
            image: null,
        },
        display: {
            imageUrl: null,
            image: null,
        },

        type: null
    }


    componentDidMount() {
        this.props.onRef(this);
    }

    initEdit = (editData) => {
        let enter = editData.enter;
        if (enter.image != null && enter.image !== "") {
            enter.image = "data:image/jpeg;base64," + enter.image.replace(/\r\n/g, "");
        }
        let display = editData.display;
        if (display.image != null && display.image !== "") {
            display.image = "data:image/jpeg;base64," + display.image.replace(/\r\n/g, "");
        }
        this.setState({ "enter": enter, "display": display, "type": editData.type });
    }

    save = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            let id = this.props.editData.id
            if (id !== undefined && id != null) {
                values["id"] = id;
            }

            //入口图片
            let enterImageUrl = this.state.enter.imageUrl;
            if (enterImageUrl != null && enterImageUrl !== "") {
                values["enterImage"] = enterImageUrl;
            } else {
                values["enterImage"] = this.state.enter.image;
            }
            if (values["enterImage"] == null || values["enterImage"] === "") {
                messager.notify("专区入口图片不能为空！");
                return;
            }
            //展示页图片
            let displayImageUrl = this.state.display.imageUrl;
            if (displayImageUrl != null && displayImageUrl !== "") {
                values["displayImage"] = displayImageUrl;
            } else {
                values["displayImage"] = this.state.display.image;
            }
            if (values["displayImage"] == null || values["displayImage"] === "") {
                messager.notify("专区展示页图片不能为空！");
                return;
            }

            // eslint-disable-next-line eqeqeq
            if (values["type"] == 1) {
                values["startTime"] = values["startTime"].format("YYYY-MM-DD HH:mm") + ":00";
                values["endTime"] = values["endTime"].format("YYYY-MM-DD HH:mm") + ":00";
            }

            http.post({
                url: '/mallSpecial/saveSpecial',
                data: values,
                success: (res) => {
                    this.props.successCallback(this.props.queryData);
                    this.props.onCancel();
                    messager.notify("保存成功！");
                }
            });
        });
    };

    handleUploadImage = (field, { base64 }) => {
        this.setState({ [field]: { "image": base64, "imageUrl": null } });
    }
    handleRemoveImage = (field, index) => {
        this.setState({ [field]: { "image": null, "imageUrl": null } });
    }

    dictSelect = (value) => {
        this.setState({ type: value });
    }

    createDom = (data) => {
        const { form, editData } = this.props;
        const { getFieldDecorator } = form;
        let dom = [];
        for (let i = 0; i < data.length; i++) {
            let item = data[i];
            // eslint-disable-next-line eqeqeq
            if (item.date === true && this.state.type != 1) {
                continue;
            }
            let itemDom = (
                <Form.Item key={i} label={item.text + "："}>
                    {item.image ?
                        <Image
                            onChange={this.handleUploadImage.bind(this, item.field)}
                            onRemove={this.handleRemoveImage.bind(this, item.field)}
                            file={this.state[item.field].image}
                            text={item.text}
                            url={this.state[item.field].imageUrl}
                        />
                        : getFieldDecorator(item.field, {
                            rules: item.rules,
                            initialValue:
                                item.date ? (editData[item.field] == null || editData[item.field] === "" ? null : moment(editData[item.field]))
                                    : editData[item.field] != null && item.select ? "" + editData[item.field] : editData[item.field],
                        })(
                            item.select ? <Select disabled={editData.id != null} onChange={this.dictSelect}>
                                <Select.Option key={0}>商户专区</Select.Option>
                                <Select.Option key={1}>活动专区</Select.Option>
                                <Select.Option key={2}>标识专区</Select.Option>
                            </Select>
                                : item.date ? <DatePicker format="YYYY-MM-DD HH:mm:00" showTime={{ format: 'HH:mm' }} style={{ width: '100%' }} />
                                    : item.number ? <InputNumber precision={0} min={1} max={999} style={{ width: '100%' }} />
                                        : item.textarea ? <Input.TextArea />
                                            : <Input />
                        )
                    }
                </Form.Item>
            );
            dom.push(itemDom);
        }
        return dom;
    };

    render() {
        const { visible, onCancel } = this.props;
        return (
            <Modal
                width={500}
                visible={visible}
                title="轮盘信息编辑"
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                afterClose={() => { this.setState({ image: null, imageUrl: null }); this.props.form.resetFields() }}
            >
                <Form layout="vertical" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
                    {this.createDom(fields)}
                </Form>
            </Modal>
        );
    }
}

const CarouselEdit = Form.create()(CarouselEditForm);

export default CarouselEdit;